import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';
import axios from 'axios';
// Async thunk to fetch the About Us data
export const fetchAboutUsData = createAsyncThunk(
  'aboutUs/fetchAboutUsData',
  async ({ language }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/api/Common/GetAboutUSPage', {
        headers: {
          'Content-Type': 'application/json',
          lang: language === 'English' ? '2' : '1',
        },
      });
      if (response.data.successtate === 200) {
        return response.data.message;
      } else {
        return rejectWithValue(response.data.errormessage || 'Failed to fetch data');
      }
    } catch (error) {
      // Capture and log detailed error information
      // console.error('Error fetching About Us data:', error);

      return rejectWithValue(
        error.response?.data?.errormessage || error.message || 'An unknown error occurred'
      );
    }
  }
);
const aboutUsSlice = createSlice({
  name: 'aboutUsFeature',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAboutUsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAboutUsData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAboutUsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default aboutUsSlice.reducer;
